<template>
  <div>
    <div v-if="isLoading">
      <OtherLoading />
    </div>
    <div v-else>
      <div>
        <div>
          <b-row class="no-gutters">
            <b-col class="text-left">
              <h1 class="mr-sm-4 header-tablepage">
                TRANSACTION DETAIL REF: {{ transactionDetail.invoice_no }}
              </h1>
            </b-col>
            <b-col class="text-right">
              <button
                type="button"
                class="btn button btn-mobile mx-2 btn-width"
                @click.prevent="deleteTransaction"
                v-if="showBtnDelete"
              >
                <span class="d-none d-sm-block">Delete</span>
                <font-awesome-icon icon="trash-alt" class="d-sm-none d-block" />
              </button>
              <button
                type="button"
                class="btn button btn-mobile btn-width"
                @click.prevent="voidTransaction"
                v-if="showBtnVoid"
              >
                <span class="d-none d-sm-block"> Void/Return </span>
                <font-awesome-icon
                  icon="paper-plane"
                  class="d-sm-none d-block"
                />
              </button>
            </b-col>
          </b-row>
        </div>
        <TransactionDetailSection
          :detail="transactionDetail"
          @modalEditNote="modalNoteEdit"
          @modalBranch="modalBranch"
          @modalCenterPoint="modalCenterPoint"
          :centerPoint="centerPoint"
          :key="updateKey"
        />

        <TransactionProductSection
          :blind="transactionDetail.blind_data_id == 3"
          :items="transactionDetail.product_list"
          :fields="fields"
        />
      </div>
    </div>
    <div class="footer-action">
      <b-col class="text-left">
        <b-button @click.prevent="beforePage" class="btn-cancel btn-width"
          >Back</b-button
        >
      </b-col>
    </div>
    <ModalEditNote
      ref="modalEditNote"
      :form="form"
      :v="$v"
      @updateNote="updateNote"
      :loadingNote="loadingNote"
    />
    <DeleteTransactionDetail
      :form="form"
      ref="modalDeleteTransaction"
      @confirmDeleteTransaction="confirmDeleteTransaction"
    />

    <VoidTransactionDetail
      :disableBtnVoid="disableBtnVoid"
      ref="modalVoidTransaction"
      :form="formVoid"
      :v="$v"
      :invoiceLength="transactionDetail.invoice_length"
      :transactionDetail="transactionDetail"
      @clearForm="clearForm"
      @confirmVoidTransaction="confirmVoidTransaction"
    />
    <ModalBranchList
      ref="modalBranchPoint"
      :fields="fieldsBranch"
      :items="itemsBranchPoint"
    />
    <ModalBranchList
      ref="modalBranchPoint"
      :fields="fieldsBranch"
      :items="itemsBranchPoint"
    />
    <!-- <ModalCenterPoint
      ref="modalCenterPoint"
      :fields="fieldsCenterPoint"
      :items="centerPoint"
    /> -->
  </div>
</template>

<script>
import OtherLoading from "@/components/loading/OtherLoading";
import TransactionDetailSection from "@/components/report/transaction/detail/TransactionDetailSection";
import TransactionProductSection from "@/components/report/transaction/detail/TransactionProductSection";
import ModalEditNote from "@/components/report/transaction/detail/ModalEditNote";
import { required, requiredIf } from "vuelidate/lib/validators";
import ModalBranchList from "@/components/report/transaction/detail/ModalBranchList";
import VoidTransactionDetail from "@/components/report/transaction/detail/VoidTransactionDetail";
import DeleteTransactionDetail from "@/components/report/transaction/detail/DeleteTransactionDetail";
export default {
  components: {
    OtherLoading,
    TransactionDetailSection,
    TransactionProductSection,
    ModalEditNote,
    ModalBranchList,
    VoidTransactionDetail,
    DeleteTransactionDetail,
  },
  validations: {
    form: {
      note: { required },
    },
    formVoid: {
      invoice_no: {
        required: requiredIf(function () {
          return this.formVoid.is_fullpos == 0;
        }),
      },
      stock_type_id: {
        required: requiredIf(function () {
          return this.formVoid.is_return_inventory == 1;
        }),
      },
    },
  },
  data() {
    return {
      isLoading: true,
      id: this.$route.params.id,
      transactionDetail: {},
      fields: [
        {
          label: "SKU / Description / Promotion",
          key: "article_no",
        },
        {
          label: "Quantity",
          key: "quantity",
        },
        {
          label: "Price (Baht)",
          key: "price",
        },
        {
          label: "Promotional Price (Baht)",
          key: "promotion_price",
        },
        {
          label: "Discount (Baht)",
          key: "sum_discount_price",
        },
        {
          label: "Net Price (Baht)",
          key: "after_discount_price",
        },
      ],
      form: {
        transaction_id: 0,
        note: "",
        is_store_credit: false,
        is_top_up_credit: false,
      },
      loadingNote: false,
      fieldsBranch: [
        {
          key: "branch_name",
          label: "Branch",
        },
        {
          key: "branch_point",
          label: "Point",
        },
      ],
      itemsBranchPoint: [],
      formVoid: {
        is_top_up_credit: false,
        transaction_id: "",
        sale_user_guid: null,
        invoice_length: 0,
        is_fullpos: 0,
        invoice_no: null,
        note: "",
        is_store_credit: false,
        is_return_inventory: 0,
        stock_type_id: 0,
        void_return_to_store_credit: 0,
      },
      formDelete: {
        transaction_id: "",
        sale_user_guid: null,
        branch_id: null,
        is_return_inventory: 0,
      },
      disableBtnVoid: false,
      showBtnDelete: true,
      showBtnVoid: true,
      fieldsCenterPoint: [
        {
          key: "center_point",
          label: "Point",
        },
      ],
      centerPoint: 0,
      updateKey: 0,
    };
  },
  async created() {
    this.getTransactionById();
    this.getNote();
  },
  destroyed() {},
  methods: {
    async getTransactionById() {
      await this.$store.dispatch("getReportTransactionById", this.id);
      const data = this.$store.state.report.stateReportTransactionById;
      if (data.result === 1) {
        this.transactionDetail = data.detail;
        this.form.is_store_credit = this.transactionDetail.is_store_credit;
        this.form.is_top_up_credit = this.transactionDetail.is_top_up_credit;
        this.form.void_return_to_store_credit =
          this.transactionDetail.void_return_to_store_credit;
        if (this.transactionDetail.transaction_ref_id) {
          if (parseInt(this.transactionDetail.transaction_ref_id) !== 0) {
            this.showBtnVoid = false;
          }
        }
        if (
          this.transactionDetail.transaction_ref_id &&
          parseInt(this.transactionDetail.transaction_ref_id) !== 0 &&
          parseInt(this.transactionDetail.status_id) === 1
        ) {
          this.showBtnDelete = false;
        }
        if (parseInt(this.transactionDetail.deleted) === 1) {
          this.showBtnDelete = false;
          this.showBtnVoid = false;
        }
        if (parseInt(this.transactionDetail.is_transaction_code) === 1) {
          this.showBtnVoid = false;
        }
        this.getBranchPoint();
        this.getPointByUser();
        this.isLoading = false;
      }
    },
    deleteTransaction() {
      this.$refs.modalDeleteTransaction.show();
    },
    voidTransaction() {
      this.formVoid.is_fullpos = this.transactionDetail.is_fullpos;
      this.formVoid.is_store_credit = this.transactionDetail.is_store_credit;
      this.formVoid.is_top_up_credit = this.transactionDetail.is_top_up_credit;

      this.formVoid.void_return_to_store_credit =
        this.transactionDetail.void_return_to_store_credit;
      this.$refs.modalVoidTransaction.show();
    },
    beforePage() {
      this.$router.push("/report/transaction");
    },
    modalNoteEdit() {
      this.$refs.modalEditNote.show();
    },
    async getNote() {
      this.loadingNote = true;
      await this.$store.dispatch("getNoteReportTransaction", this.id);
      const data = this.$store.state.report.stateNoteReportTransaction;
      if (data.result === 1) {
        this.transactionDetail.note = data.detail.note;
        this.form.note = data.detail.note;
      }
      this.loadingNote = false;
    },
    async updateNote(val) {
      // this.loadingNote = true;
      this.$bus.$emit("showLoading");
      this.form.transaction_id = this.transactionDetail.transaction_id;
      this.form.note = val.note;
      await this.$store.dispatch("updateNoteReportTransaction", this.form);
      const data = this.$store.state.report.stateUpdateNoteReportTransaction;
      this.$bus.$emit("hideLoading");
      this.$refs.modalEditNote.hide();
      if (data.result === 1) {
        this.successAlert();
        this.getNote();
      } else {
        this.errorAlert(data.message);
      }
    },
    modalCenterPoint() {
      this.$refs.modalCenterPoint.show();
    },
    modalBranch() {
      this.$refs.modalBranchPoint.show();
    },
    async getBranchPoint() {
      if (this.transactionDetail.blind_data_id == 3) return;
      await this.$store.dispatch(
        "getTransactionBranchPoint",
        this.transactionDetail.user_guid
      );
      const data = this.$store.state.report.stateTransactionBranchPoint;
      if (data.result === 1) {
        this.itemsBranchPoint = data.detail.listBranchPoint;
      }
    },
    async getPointByUser() {
      if (this.transactionDetail.blind_data_id == 3) return;
      await this.$store.dispatch(
        "getPointByReportCustomer",
        this.transactionDetail.user_guid
      );
      const data = this.$store.state.report.stateGetPointByReportCustomer;
      if (data.result === 1) {
        this.centerPoint = data.detail.center_point;
      }
    },
    async confirmVoidTransaction(val) {
      this.disableBtnVoid = true;
      this.$bus.$emit("showLoading");
      this.formVoid.invoice_no = val.invoice_no;
      this.formVoid.transaction_id = this.transactionDetail.transaction_id;
      this.formVoid.sale_user_guid = this.$cookies.get(
        "back_office_admin_user_guid"
      );
      this.formVoid.note = val.note;
      this.formVoid.is_return_store_credit = val.is_return_store_credit;
      this.formVoid.stock_type_id = val.stock_type_id;
      await this.$store.dispatch("voidTransactionById", this.formVoid);
      const data = this.$store.state.report.stateVoidTransactionById;
      this.$bus.$emit("hideLoading");
      if (data.result === 1) {
        this.successAlert(data.message).then(() => {
          this.$refs.modalVoidTransaction.hide();
          this.getTransactionById();
          this.getNote();
          this.getBranchPoint();
          this.getPointByUser();
        });
      } else {
        this.disableBtnVoid = false;
        this.errorAlert(data.message);
      }
    },
    async confirmDeleteTransaction(isReturn) {
      this.formDelete.transaction_id = this.transactionDetail.transaction_id;
      this.formDelete.sale_user_guid = this.$cookies.get(
        "back_office_admin_user_guid"
      );
      this.formDelete.branch_id = this.transactionDetail.branch_id;
      this.formDelete.is_return_inventory = isReturn;

      this.$bus.$emit("showLoading");
      await this.$store.dispatch("deleteTransactionById", this.formDelete);
      const data = this.$store.state.report.stateDeleteTransactionById;
      this.$bus.$emit("hideLoading");
      if (data.result === 1) {
        this.successAlert().then(function () {
          window.location.reload();
        });
      } else {
        this.errorAlert(data.message);
      }
    },
    clearForm() {
      this.formVoid = {
        is_top_up_credit: false,
        transaction_id: "",
        sale_user_guid: null,
        invoice_length: 0,
        is_fullpos: 0,
        invoice_no: null,
        note: "",
        is_store_credit: false,
        is_return_inventory: 0,
        stock_type_id: 0,
        void_return_to_store_credit: 0,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.footer {
  z-index: 2;
  position: fixed;
  bottom: 0;
  left: 256px;
  right: 0;
  padding: 10px;
  background: #fff;
}
.btn-confirm-automation {
  color: #fff;
  border-radius: 0px;
  border-color: var(--primary-color);
  background-color: var(--primary-color);
  width: 30%;
}
@media (min-width: 350px) and (max-width: 991px) {
  .footer-action {
    padding-left: 0 !important;
    padding-right: 0 !important;
    padding-top: 15px;
    padding-bottom: 15px;
  }
}
.footer-action {
  margin-left: var(--margin-spacing);
  z-index: 2;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 15px;
  background: #fff;
  display: flex;
  flex-direction: row;
  transition: margin-left 0.25s, margin-right 0.25s, width 0.25s, flex 0.25s;
}
</style>
